/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { zoomModalClick } from '../../../analytics';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  zoomModalClick();
}), false, { type: 'TRACK_ZOOM_MODAL_CLICK' });
